export default [
  { value: 'none', label: 'none' },
  { value: 'In-ground', label: 'In-ground' },
];
